import React, { useState, useEffect } from 'react';
import { SketchPicker } from 'react-color';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

const LasLayerControls = ({ layer, index, lasLayers, setLasLayers }) => {
    const [classSettings, setClassSettings] = useState({});
    const [activeColorPicker, setActiveColorPicker] = useState(null);

    useEffect(() => {
        const data = layer.props.data;
        setClassSettings(prev => {
            const newSettings = { ...prev };
            let changed = false;

            data.forEach(d => {
                const cls = d.classification ?? 0;
                if (!(cls in newSettings)) {
                    newSettings[cls] = {
                        visible: true,
                        color: d.color ?? [255, 255, 255, 255]
                    };
                    changed = true;
                }
            });

            return changed ? newSettings : prev;
        });
    }, [layer.id, layer.props.data]);

    const applyClassSettings = (newSettings) => {
        const updatedData = layer.props.data.map(d => {
            const cls = d.classification ?? 0;
            const setting = newSettings[cls];
            return setting?.visible
                ? { ...d, color: setting.color }
                : { ...d, color: [0, 0, 0, 0] };
        });

        const updatedLayer = layer.clone({ data: updatedData });
        const newLayers = [...lasLayers];
        newLayers[index] = updatedLayer;
        setLasLayers(newLayers);
    };

    const toggleVisibility = (cls) => {
        const newSettings = {
            ...classSettings,
            [cls]: {
                ...classSettings[cls],
                visible: !classSettings[cls].visible
            }
        };
        setClassSettings(newSettings);
        applyClassSettings(newSettings);
    };

    const changeColor = (cls, color) => {
        const newSettings = {
            ...classSettings,
            [cls]: {
                ...classSettings[cls],
                color: [color.rgb.r, color.rgb.g, color.rgb.b, 255]
            }
        };
        setClassSettings(newSettings);
        applyClassSettings(newSettings);
    };

    return (
        <div style={{ marginTop: '12px' }}>
            <h6 style={{ fontWeight: 'bold' }}>Klase i boje</h6>
            {Object.entries(classSettings).map(([cls, setting]) => (
                <div key={cls} style={{
                    marginBottom: '12px',
                    background: '#191947',
                    borderRadius: '8px',
                    padding: '8px 5px'
                }}>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}>
                        <span style={{ fontWeight: 'bold' }}>{cls}</span>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <div
                                onClick={() =>
                                    setActiveColorPicker(activeColorPicker === cls ? null : cls)
                                }
                                style={{
                                    width: '32px',
                                    height: '14px',
                                    borderRadius: '6px',
                                    backgroundColor: `rgba(${setting.color.join(',')})`,
                                    border: '1px solid white',
                                    cursor: 'pointer'
                                }}
                            />
                            <button
                                onClick={() => toggleVisibility(cls)}
                                style={{ border: 'none', background: 'none', cursor: 'pointer', color: 'white' }}
                                title={setting.visible ? "Sakrij klasu" : "Prikaži klasu"}
                            >
                                {setting.visible ? <FaEye /> : <FaEyeSlash />}
                            </button>
                        </div>
                    </div>
                    {activeColorPicker === cls && (
                        <div style={{ marginTop: '10px', zIndex: 9999 }}>
                            <SketchPicker
                                color={{
                                    r: setting.color[0],
                                    g: setting.color[1],
                                    b: setting.color[2],
                                }}
                                onChange={(color) => changeColor(cls, color)}
                                disableAlpha
                                presetColors={[]}
                                styles={{
                                    default: {
                                        picker: {
                                            width: '150px', // manja širina
                                            boxShadow: 'none',
                                        }
                                    }
                                }}
                            />

                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};

export default LasLayerControls;
